import React from "react";
import { Box, Stack, Typography } from "@mui/material";

const DAYS = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

const HorairesFooter = ({ hours, activationRange }) => {
  if (!hours) return null;

  return (
    <Stack spacing={2}>
      {DAYS.map((dayKey) => {
        const day = hours[dayKey];
        if (!day) return null;

        return (
          <Box key={dayKey}>
            <Typography variant="subtitle2" fontWeight={600}>
              {day.name}
            </Typography>

            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ ml: 2, mt: 0.5 }}
            >
              {day.slots?.length
                ? day.slots.join(" / ")
                : activationRange
                  ? "Non disponible"
                  : "Fermé"}
            </Typography>
          </Box>
        );
      })}
    </Stack>
  );
};

export default HorairesFooter;
